import React, {FC} from 'react';
import {Box, Typography} from '@mui/material';
import {styled, Theme} from '@mui/material/styles';
import BuildIcon from '@mui/icons-material/Build';
import $config from '../config';

type KnownEnvironment = 'Sandbox' | 'Staging' | 'Dev' | 'Dev2';
type AppConfig = {environmentMode?: string};

const ENV_COLORS: Record<KnownEnvironment, string> = {
    Sandbox: '#aea116',
    Staging: '#6B8E23',
    Dev: '#2E8B57',
    Dev2: '#2E8B57',
};

interface StyledBannerProps {
    bgcolor: string;
}

const StyledBanner = styled(Box)<StyledBannerProps>(({theme, bgcolor}: {theme: Theme; bgcolor: string}) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: bgcolor,
    color: '#FFFFFF',
    opacity: 0.85,
    padding: theme.spacing(0.25, 2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(0.6),
    zIndex: theme.zIndex.modal + 100,
}));

const PulsingIcon = styled(BuildIcon)({
    fontSize: '0.713rem',
    flexShrink: 0,
    animation: 'pulse 2s ease-in-out infinite',
    '@keyframes pulse': {
        '0%, 100%': {opacity: 1},
        '50%': {opacity: 0.6},
    },
});

const BannerText = styled(Typography)({
    fontWeight: 700,
    fontSize: '0.613rem',
    letterSpacing: '0.5px',
    whiteSpace: 'nowrap',
});

const BannerEnvironmentName = styled(Typography)({
    fontWeight: 400,
    fontSize: '0.613rem',
    opacity: 0.9,
    whiteSpace: 'nowrap',
});

const EnvironmentBanner: FC = (): JSX.Element | null => {
    const environmentName = (($config as AppConfig).environmentMode ?? undefined) as KnownEnvironment | undefined;

    if (!environmentName) {
        return null;
    }

    const bannerColor: string = ENV_COLORS[environmentName] ?? '#2E8B57';

    return (
        <StyledBanner role="banner" aria-label={`Тестовый контур: ${environmentName}`} component="div" bgcolor={bannerColor}>
            <PulsingIcon />
            <BannerText variant="body2">Тестовый контур</BannerText>
            <BannerEnvironmentName variant="body2">({environmentName})</BannerEnvironmentName>
        </StyledBanner>
    );
};

export default EnvironmentBanner;
